import * as React from 'react'
import { graphql } from 'gatsby'
import FleetFinancingView from '../../views/fleetFinancingView'

const FleetFinancingPage = (props) => (
  <FleetFinancingView {...props} productFeatureType="fleet" />
)
export default FleetFinancingPage

export const query = graphql`
  query FleetFinancingQuery($slug: String, $locale: String) {
    header: contentfulHeader(node_locale: { eq: $locale }) {
      ...headerFragment
    }
    footer: contentfulFooter(node_locale: { eq: $locale }) {
      ...footerFragment
    }
    waitingList: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...waitingListFragment
    }
    hero: contentfulHeroSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...heroFragment
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      metaDescription
      metaTag
      title
      slug
      sections: pageSection {
        ...leasingDetailSectionFragment
        ...servicesFragment
        ... on ContentfulImageAnimation {
          bucketUrl
          href
          image {
            file {
              url
              contentType
            }
          }
        }
        ... on ContentfulHeroSection {
          id
          heading
          isHeadingXRay
          bannerCta {
            link
            text
          }
          description {
            raw
          }
          bannerImageUrl
          bannerImages {
            ... on ContentfulImageAnimation {
              bucketUrl
              image {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
